import { render, staticRenderFns } from "./AcceptedInner.vue?vue&type=template&id=06624c8c&"
import script from "./AcceptedInner.vue?vue&type=script&lang=js&"
export * from "./AcceptedInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports